<script>
import VueApexCharts from 'vue3-apexcharts';

export default {
    name: 'DashboardApexChart',
    components: {
        apexchart: VueApexCharts,
    },
    props: {
        chart: {
            type: Object,
            required: true,
        },
        chartType: {
            type: String,
            default: 'line',
        },
    },
    computed: {
        apexType() {
            return this.chartType === 'column' ? 'bar' : this.chartType;
        },
        series() {
            return (this.chart.series ?? []).map((item) => ({
                name: item.name,
                data: item.data,
            }));
        },
        options() {
            const isScatter = this.apexType === 'scatter';

            return {
                chart: {
                    id: `dashboard-chart-${this.chart.granularity}`,
                    toolbar: { show: false },
                },
                stroke: {
                    curve: 'smooth',
                    width: isScatter ? 0 : 2,
                },
                markers: {
                    size: isScatter ? 6 : 0,
                },
                dataLabels: { enabled: false },
                xaxis: {
                    categories: this.chart.categories ?? [],
                    labels: {
                        rotate: this.chart.granularity === 'hour' ? -45 : 0,
                    },
                },
                yaxis: {
                    labels: {
                        formatter: (value) => Number(value ?? 0).toLocaleString('it-IT'),
                    },
                },
                tooltip: {
                    y: {
                        formatter: (value) => Number(value ?? 0).toLocaleString('it-IT'),
                    },
                },
                legend: {
                    position: 'top',
                },
            };
        },
    },
};
</script>

<template>
    <div class="dashboard-apex-chart" style="min-height: 260px">
        <apexchart
            :type="apexType"
            height="260"
            :options="options"
            :series="series"
        />
    </div>
</template>
